import React, { useState, useEffect } from "react";
import {getInputSimulationFile,getOutputSimulationFile} from "../../../../api/user";
import {get} from "../../../../api/get";
import {getContarError} from "../../../../api/user";
import { basePath, apiVersion } from "../../../../api/config";

import {
  List,
  Button,
  Select,
  Modal as ModalAntd,
  notification,
} from "antd";
import {
  CloudDownloadOutlined,
  BarChartOutlined,
  DeleteOutlined,
  SearchOutlined,
  RedoOutlined,
} from "@ant-design/icons";

import {
  Form,
  Input,
  
} from "antd";

import { Upload } from "antd";
import { getAccessTokenApi ,getRefreshTokenApi,getPublicIP} from "../../../../api/auth";

import "./ListOutputs.scss";

const { confirm } = ModalAntd;
export default function ListOutputs(props) {
  const { simulations, setReloadUsers } = props;
  const [inputs, setInputs] = useState([]);
  const [circular, setcircular] = useState(false);
  const [tr, setTr] = useState([]);
  const { Option } = Select;
  //console.log("+++");
  //console.log(props);
  const token = getAccessTokenApi();
  var trt;

  useEffect(() => {
    var aux=[];
    var auxi=[];
    //  console.log(simulations)
    for (let i=0; i<simulations.length;i++){
      aux=[...aux,simulations[i].nombre]
      auxi=[...auxi,false]
      //  console.log(i,auxi)
    }
    setInputs(aux)
    setTr(auxi)

  //  console.log(aux,'inputs')
  //  console.log(simulations,'simulations')
  },[simulations]); 

  function deleteSimulationFile(token, id_simulation) {
    const url = `${basePath}/${apiVersion}/user-simulacion/${id_simulation}`;
    const refreshToken = getRefreshTokenApi();
    var status;
  var urlFetch='';
  var messag='';
    const params = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'deleteSimulationFile',
          ippublica:getPublicIP()
      },
    };
    return fetch(url, params)
    .then((response) => {
        status=response.status;
        urlFetch=response.url;
        urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        setReloadUsers(true);
        return response.json();
      })
      .then((result) => {
        if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }
 
  function deleteSimulationFileMult(token, id_simulation) {
    const url = `${basePath}/${apiVersion}/user-simulacion-mult/${id_simulation}`;
    const refreshToken = getRefreshTokenApi();
    var status;
  var urlFetch='';
  var messag='';
  //console.log(url);
    const params = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'deleteSimulationFile',
          ippublica:getPublicIP()
      },
    };

    return fetch(url, params)
      .then((response) => {
        notification["success"]({
          message: response.json(),
        });
        status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        setReloadUsers(true);
        //console.log(response);
        return response.json();
      })
      .then((result) => {
        if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async function downloadFilefromItaMultiple(token, id_simulation) {
    const url = `${basePath}/${apiVersion}/busca-ita-multiple/${id_simulation}`;
    const refreshToken = getRefreshTokenApi();
    var status;
    var urlFetch='';
    var messag='';
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'downloadFilefromItaMultiple',
          ippublica:getPublicIP()
      },
    };

    
    return fetch(url, params)
      .then((response) => {
        status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.json();
      })
      .then(async (result) => {
        if(status===202){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }else if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }else{

          await actualizarUserMult(token, id_simulation);
          setReloadUsers(true);
        }
        
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

   async function downloadFilefromIta(token, id_simulation) {
    const url = `${basePath}/${apiVersion}/busca-ita/${id_simulation}`;
    const refreshToken = getRefreshTokenApi();
    var status;
    var urlFetch='';
    var messag='';
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'downloadFilefromIta',
          ippublica:getPublicIP()
      },
    };

    
    return fetch(url, params)
      .then((response) => {
        status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.json();
      })
      .then(async (result) => {
        if(status===202){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }else if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }else{

          // await actualizarUser(token, id_simulation);
          setReloadUsers(true);
        }
       //console.log('OUT')
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async function actualizarUser(token, id_simulation) {  
    const ficheros = {'file': id_simulation}
    const refreshToken = getRefreshTokenApi();
    var status;
    var urlFetch='';
    var messag='';

    const url = `${basePath}/${apiVersion}/subir-result`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'actualizarUser',
          ippublica:getPublicIP()
      },
      body: JSON.stringify(ficheros),
    };

   //console.log('salgo actualizo');
    return fetch(url, params)
      .then((response) => {
        status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.json();
      })
      .then((result) => {
        //console.log(result);
        if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }
        return result;
      })
      .catch((err) => {
       //console.log('estoy acullá');
        return err.message;
      });
  }

  async function actualizarUserMult(token, id_simulation) {  
    const ficheros = {'file': id_simulation}
    const refreshToken = getRefreshTokenApi();
    var status;
    var urlFetch='';
    var messag='';

    const url = `${basePath}/${apiVersion}/subir-result-mult`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        refreshToken: "Bearer " + refreshToken,
          functionname:'actualizarUser',
          ippublica:getPublicIP()
      },
      body: JSON.stringify(ficheros),
    };

   //console.log('salgo actualizo');
    return fetch(url, params)
      .then((response) => {
        status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.json();
      })
      .then((result) => {
        //console.log(result);
        if(status!==200){
          messag=result.message
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
            description:messag
          });
          getContarError(urlFetch,messag);
        }
        return result;
      })
      .catch((err) => {
       //console.log('estoy acullá');
        return err.message;
      });
  }

  
  function updateNames(nombreOutput,token,index) {
    try{
      var status;
    var urlFetch='';
    var messag='';
      const refreshToken = getRefreshTokenApi();
     //console.log('inputs: ',inputs[index],'; nombreOutput: ',nombreOutput,'; userId: ',token);
      const datos = {
        simulation_id: nombreOutput,
        name:inputs[index]
      }
      const url = `${basePath}/${apiVersion}/change-simulation-name`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          refreshToken: "Bearer " + refreshToken,
          functionname:'updateNames',
          ippublica:getPublicIP()
        },
        body: JSON.stringify(datos),
      };
  
     //console.log('salgo actualizo');
      return fetch(url, params)
        .then((response) => {
          status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
          return response.json();
        })
        .then((result) => {
          if(status!==200){
            messag=result.message
            notification["error"]({
              message: `Error ${status} in function: ${urlFetch}`,
              description:messag
            });
            getContarError(urlFetch,messag);
          }
          setReloadUsers(true);
          return result;
        })
        .catch((err) => {
         //console.log('estoy acullá');
          return err.message;
        });
      
      
    }catch(error){
     //console.log(error)
    }
  };



  return (
    <div className="list-users">
      {}
      <List
        //header={<div>Resultados de las simulaciones</div>}
        //footer={<div>No hay más simulaciones</div>}
        bordered
        dataSource={simulations}
        renderItem={(item,index) => (
          
          <List.Item className="content"
            /* style={{ backgroundColor: "white", justifyContent: "space-around" }} */
          >
            
            <div className="fechaboton1">
              <Form className="form" 
                  onChange={(e) =>
                    { 
                      var aux=inputs;
                      aux[index]=e.target.value;
                      setInputs(aux)
                    //console.log(inputs)
                    }
                  } 
                  onFinish={()=>updateNames(item.nombreOutput,token,index)}>
                <h1 style={{fontFamily: 'report',marginBottom:'0px'}}>Date: {item.horaInput}</h1>
                <h1 style={{fontFamily: 'report',marginBottom:'0px'}}>Is daily operation? {(item.isDailyOperation||false)?'Yes':'No'}</h1>
                <h1 style={{fontFamily: 'report',marginBottom:'0px'}}>Name: {inputs[index]}</h1>
                <Form.Item>
                    <Input
                      //prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                      type="name"
                      style={{fontFamily: 'report'}}
                      name="name"
                      /*value={inputs[index]
                        ()=>{
                          var j = 0;
                          for (let i=0; i<simulations.length;i++){
                            if(item.nombre===inputs[i]){
                              j=i;
                            }
                            }
                          return inputs[j];} 
                      }*/
                      placeholder="Simulation Name"
                      className=""
                    />
                  </Form.Item>
                 <Form.Item>
                    <Button type="primary" 
                     style={{
                      backgroundColor:(inputs[index]==undefined||inputs[index]=='')?'rgb(220,220,220)':'white',
                      borderWidth:'2px',
                      fontSize:'15px',
                      color:(inputs[index]==undefined||inputs[index]=='')?'grey':'rgb(35,148,212)',
                      borderColor:(inputs[index]==undefined||inputs[index]=='')?'grey':'rgb(35,148,212)',
                      fontFamily: 'report-bold'
                    }}
                    disabled={(inputs[index]==undefined||inputs[index]=='')?true:false} htmlType="submit" className="login-form__button">
                      Update Name
                    </Button>
                  </Form.Item>
             </Form>
            </div>
            
            {/* <div className="content"> */}
              {/* <div className="fechaboton"
                style={{ backgroundColor: "white" }}> */}
                  
               
                {/* <div
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                    fontFamily: 'report'
                  }}
                >
                  <Button
                    type="primary"
                    style={{
                      backgroundColor:'white',
                      borderWidth:'2px',
                      color:'rgb(0,104,178)',
                      fontSize:'15px',
                      borderColor:'rgb(35,148,212)',
                      fontFamily: 'report-bold'
                    }}
                    onClick={() => {
                      get('get-input-simulacion','get-input-simulacion',`/${item.nombreInput}`);
                      // getInputSimulationFile(token, item.nombreInput);
                      
                      //console.log("Dentro");
                    }}
                  >
                    <CloudDownloadOutlined />
                    Download Data Input
                  </Button>
                  <p></p>
                </div> */}
                {/* {(simulations[index].simulaciones.length!==0)
                ?<div style={{ maxHeight: '170px', overflowY: 'auto' }}>
                  <List
                      //header={<div>Resultados de las simulaciones</div>}
                      //footer={<div>No hay más simulaciones</div>}
                      bordered
                      dataSource={simulations[index].simulaciones}
                      renderItem={(item,index) => (
                        
                        <List.Item style={{border: '2px solid rgb(203,234,247)'}} className="content">
                          <div
                              style={{
                                justifyContent: "center",
                                textAlign: "center",
                                fontFamily: 'report'
                              }}
                            >
                            <Button
                              type="primary"
                              style={{
                                backgroundColor:'white',
                                borderWidth:'2px',
                                fontSize:'15px',
                                color:'rgb(0,104,178)',
                                borderColor:'rgb(35,148,212)',
                                fontFamily: 'report-bold'
                              }}
                              onClick={() => {
                                getInputSimulationFile(token, item.nombreInput);
                                //console.log("Dentro");
                              }}
                            >
                              <CloudDownloadOutlined />
                              {String(item.nombreInput).substring(13)}
                            </Button>
                          </div>
                          <div
                            style={{
                              justifyContent: "center",
                              textAlign: "center",
                              fontFamily: 'report'
                            }}
                          >
                            
                          </div>
                         </List.Item>
                      )}
                    />
                    </div>
                  :<p></p>
                } */}
              {/* </div> */}
              
              
              <div className="fechaboton">
                <div 
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  {item.nombreOutput == "" ? (
                  <Button
                    disabled={true}
                    style={{
                      backgroundColor:'rgb(220,220,220)',
                      borderWidth:'2px',
                      fontSize:'15px',
                      borderColor:'#737373',
                      fontFamily: 'report-bold'
                    }}
                    type="primary"
                    onClick={ () => {
                      //  get('get-output-simulacion','get-output-simulacion', `/${item.nombreOutput}`);
                       getOutputSimulationFile(token, item.nombreOutput);
                      //console.log("Dentro");
                    }}
                  >
                    <CloudDownloadOutlined  style={{
                      color:'#737373',
                    }}/>
                    Download Results
                  </Button>
                  ) : (
                  <Button
                  style={{
                    backgroundColor:'white',
                    borderWidth:'2px',
                    fontSize:'15px',
                    borderColor:'green',
                    color:'green',
                    fontFamily: 'report-bold'
                  }}
                    type="primary"
                    onClick={ () => {
                      //  get('get-output-simulacion','get-output-simulacion', `/${item.nombreOutput}`);
                      // console.log("Dentro1");
                       getOutputSimulationFile(token, item.nombreOutput);
                      // console.log("Dentro2");
                    }}
                  >
                    <CloudDownloadOutlined style={{
                      color:'green',
                    }}/>
                    Download Results
                  </Button>
                )}
                
                </div>
                <p></p>
              {/* </div> */}
             

{/*               
              {(simulations[index].simulaciones.length!==0)
                ?<div style={{ maxHeight: '170px', overflowY: 'auto' }}>
              <List
                      //header={<div>Resultados de las simulaciones</div>}
                      //footer={<div>No hay más simulaciones</div>}
                      bordered
                      dataSource={simulations[index].simulaciones}
                      renderItem={(item,inde) => (
                        
                        trt=tr,
                        (trt[index]==false&&inde!=0)
                        ?trt[index]=false
                        :(item.nombreOutput == "" )
                        ?trt[index]=false
                        :trt[index]=true,
                        
                        setTr(trt),
                        
                        <List.Item style={{border: '2px solid rgb(203,234,247)'}} className="content">
                          <div 
                              style={{
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              >
                              <p></p>
                              {item.nombreOutput == "" ? (
                                <Button
                                disabled={true}
                                style={{
                                  backgroundColor:'rgb(220,220,220)',
                                  borderWidth:'2px',
                                  fontSize:'15px',
                                  borderColor:'#737373',
                                  fontFamily: 'report-bold'
                                }}
                                type="primary"
                                onClick={ () => {
                                  
                                  getOutputSimulationFile(token, item.nombreOutput);
                                  
                                  //console.log("Dentro");
                                }}
                                >
                                <CloudDownloadOutlined />
                                {String(item.nombreInput).substring(13)}
                              </Button>
                            ) : (
                              <Button
                              style={{
                                backgroundColor:'white',
                                borderWidth:'2px',
                                color:'green',
                                fontSize:'15px',
                                borderColor:'green',
                                fontFamily: 'report-bold'
                              }}
                              type="primary"
                              onClick={ () => {
                                
                                getOutputSimulationFile(token, item.nombreOutput);
                                
                                //console.log("Dentro");
                              }}
                              >
                                <CloudDownloadOutlined />
                                {String(item.nombreInput).substring(13)}
                              </Button>
                              )}
                              <p></p>
                               
                            </div>
                            
                            <div style={{marginLeft:'15px',marginRight:'12px',marginTop:'10px',marginBottom:'10px'}}>
                              <Button className="boton"
                              style={{
                                backgroundColor:'white',
                                borderWidth:'2px',
                                fontSize:'15px',
                                borderColor:'red',
                              }}
                              type="danger"
                              onClick={async () => {
                                //console.log('hola hola',item.nombreInput)
                                await deleteSimulationFileMult(token, item.nombreInput);
                              }}
                              >
                                <DeleteOutlined style={{
                                  color:'red',
                              }}/>
                              </Button>
                              <p></p>
                              {item.nombreOutput == "" 
                              ?<Button
                              className="boton"
                              style={{
                                backgroundColor:'white',
                                borderWidth:'2px',
                                fontSize:'15px',
                                borderColor:'orange',
                              }}
                                  type="danger"
                                  onClick={async () => {
                                    //console.log('hola hola',item.nombreInput)
                                    setcircular(true)
                                    await downloadFilefromItaMultiple(token, item.nombreInput);
                                    setcircular(false)
                                  }}
                                  >
                                  <RedoOutlined style={{
                                    color:'orange',
                                  }}/>
                                </Button>
                                :<Button className="boton"
                                    disabled={true}
                                    style={{
                                      backgroundColor:'rgb(220,220,220)',
                                      borderWidth:'2px',
                                      fontSize:'15px',
                                      borderColor:'grey',
                                    }}
                                    type="danger"
                                    onClick={async () => {
                                      //console.log('hola hola',item.nombreInput)
                                      setcircular(true)
                                      await downloadFilefromItaMultiple(token, item.nombreInput);
                                      setcircular(false)
                                    }}
                                  >
                                    <RedoOutlined style={{
                                      color:'grey',
                                    }}/>
                                  </Button>
                                } 
                                {
                                (circular)
                                ?<div className="cargandoOutput">
                                  </div>
                                :<div className="vacioOutput">
                                  </div>
                                }
                            </div>
                            {item.nombreOutput == "" 
                              ?<Button className="boton"
                              disabled={true}
                              style={{
                                backgroundColor:'rgb(220,220,220)',
                                borderWidth:'2px',
                                fontSize:'15px',
                                borderColor:'grey',
                              }}
                              
                              type="primary"
                              >
                                  <SearchOutlined style={{
                                    color:'grey',
                                  }}/>
                                </Button>
                                :<Button className="boton"
                                    //style={{ borderColor: "green", backgroundColor: "green" }}
                                    style={{
                                      backgroundColor:'white',
                                      borderWidth:'2px',
                                      fontSize:'15px',
                                      borderColor:'rgb(35,148,212)',
                                    }}
                                    type="primary"
                                    onClick={async () => {
                                      window.location.href = `/admin/graphOUTPUTS?id=${item.nombreInput}`;
                                    }}
                                    >
                                    <SearchOutlined style={{
                                      color:'rgb(35,148,212)',
                                    }}/>
                                  </Button>
                                }
                         </List.Item>
                      )}
                    />
                 </div>
                  :<p></p>
                } */}
            </div>

            <div className="botones">
            {item.nombreOutput == "" 
              ?<Button className="boton"
                  disabled={true}
                  style={{
                    backgroundColor:'rgb(220,220,220)',
                    borderWidth:'2px',
                    fontSize:'15px',
                    borderColor:'grey',
                    color:'grey',
                    fontFamily:'report'
                  }}
                  
                  type="primary"
                  /*  onClick={async () => {
                    window.location.href = `/admin/graph?id=${item.nombreInput}`;
                  }} */
                  >
                  Show Results
                  <SearchOutlined style={{
                    color:'grey',
                  }}/>
                </Button>
                :<Button className="boton"
                //style={{ borderColor: "green", backgroundColor: "green" }}
                style={{
                      color:'rgb(35,148,212)',
                      fontFamily:'report',
                      backgroundColor:'white',
                      borderWidth:'2px',
                      fontSize:'15px',
                      borderColor:'rgb(35,148,212)',
                    }}
                    type="primary"
                    onClick={async () => {
                      window.location.href =`/admin/graphOUTPUTS?id=${item.nombreInput}`;
                    }}
                  >
                    Show Results
                    <SearchOutlined style={{
                      color:'rgb(35,148,212)',
                    }}/>
                  </Button>
                }
              <p></p>
              {
              // (item.simulaciones.length >0) 
              // ?(item.nombreOutput.length >0 && tr[index])
                // ?<Button className="boton"
                // disabled={false}
                // style={{
                //   borderWidth:'2px',
                //   fontSize:'15px',
                //   backgroundColor:'rgb(220,220,220)',
                //   borderColor:'grey',
                //   color:'grey',
                //   fontFamily:'report'
                // }}
                //   type="primary"
                //    onClick={async () => {
                    // console.log('true: ',item.nombreOutput.length >0 && tr[index]);
                    // console.log('ahi va: ',tr[index]);
                    // console.log('item.nombreOutput.length: ',item.nombreOutput.length);
                  //   window.location.href = `/admin/graph-mult?id=${item.nombreInput}`;
                  // }}
                  /*  onClick={async () => {
                    window.location.href = `/admin/graph?id=${item.nombreInput}`;
                  }} */
                //   >
                //     Show Multisimulation
                //  <BarChartOutlined style={{
                //     color:'grey',
                //   }}/>
                // </Button>
                // :<Button className="boton"
                // disabled={false}
                // style={{
                //   borderWidth:'2px',
                //   fontSize:'15px',
                //   backgroundColor:'white',
                //   borderColor:'purple',
                //   color:'purple',
                //   fontFamily:'report'
                // }}
                
                // type="primary"
                // onClick={async () => {
                //   // console.log(item.nombreOutput.length >0,'is')
                //   // console.log(simulations[index],'if')
                //   if(simulations[index].pesos.length<1){
                //     notification["error"]({
                //       message: `Error en los pesos asociados a la multisimulación`,
                //       description:'Tienes que añadir unos pesos a la simulación para poder comparar todas las simulaciones.'
                //     });
                //   }else{
                //     var isMulti = true
                //     for (let i=0; i<simulations[index].simulaciones.length;i++){
                //       if(simulations[index].simulaciones[i].nombreOutput.length<1){
                //         isMulti = false
                //         break;
                //       }
                //     }
                //     (item.nombreOutput.length >0 && isMulti)
                //     ?window.location.href = `/admin/graph-mult?id=${item.nombreInput}`
                //     :notification["error"]({
                //       message: `Error al cargar la vista conjunta.`,
                //       description:'Tienes que cargar todas las simulaciones para ver la vista multiple'
                //     });
                    // console.log('false: ',item.nombreOutput.length >0 && tr[index]);
                    // console.log('ahi va: ',tr[index]);
                    // console.log('item.nombreOutput.length: ',item.nombreOutput.length);
                //   }
                 
                // }}
               /*  onClick={async () => {
                  window.location.href = `/admin/graph?id=${item.nombreInput}`;
                }} */
              // > Show Multisimulation
              //  <BarChartOutlined style={{
              //       color:'purple',
              //       // color:'grey',
              //     }}/>
              // </Button>
              //   :<div></div>
                }
                <p></p>
              <Button className="boton"
              style={{
                backgroundColor:'white',
                borderWidth:'2px',
                fontSize:'15px',
                borderColor:'red',
                color:'red',
                fontFamily:'report'
              }}
                type="danger"
                onClick={async () => {
                  //console.log('hola hola',item.nombreInput)
                  // console.log('delete1')
                  await deleteSimulationFile(token, item.nombreInput);
                  // console.log('delete2')
                }}
              >
                Delete Simulation
                <DeleteOutlined style={{
                    color:'red',
                  }}/>
              </Button>
              <p></p>
              {item.nombreOutput == "" 
              ?<Button
              className="boton"
                  style={{
                    backgroundColor:'white',
                    borderWidth:'2px',
                    fontSize:'15px',
                    borderColor:'orange',
                    color:'orange',
                    fontFamily:'report'
                  }}
                  type="danger"
                  onClick={async () => {
                    //console.log('hola hola',item.nombreInput)
                    setcircular(true)
                    // await get('busca-ita','busca-ita',`/${item.nombreInput}`)
                    await downloadFilefromIta(token, item.nombreInput);
                    setcircular(false)
                  }}
                >
                  Upload Results
                  <RedoOutlined style={{
                    color:'orange',
                  }}/>
                </Button>
                :<Button className="boton"
                disabled={true}
                style={{
                  backgroundColor:'rgb(220,220,220)',
                  borderColor:'grey',
                  color:'grey',
                  borderWidth:'2px',
                  fontFamily:'report',
                  fontSize:'15px',
                }}
                type="danger"
                onClick={async () => {
                  //console.log('hola hola',item.nombreInput)
                  setcircular(true)
                  // await get('busca-ita','busca-ita',`/${item.nombreInput}`)
                  await downloadFilefromIta(token, item.nombreInput);
                  setcircular(false)
                }}
              >
                Upload Results
                <RedoOutlined style={{
                    color:'grey',
                  }}/>
              </Button>
                }
                  {
                  (circular)
                  ?<div className="cargandoOutput">
                    </div>
                  :<div className="vacioOutput">
                    </div>
                  }
            </div>
          </List.Item>
        )}
      />
      
    </div>
  );
}
